const Style = ({ attributes, clientId }) => {
	const { width, alignment, textAlign, typography, colors, padding, border, shadow } = attributes;

	return <style dangerouslySetInnerHTML={{
		__html: `
		${typography?.googleFontLink ? `@import url(${typography?.googleFontLink});` : ''}

		#abbAlertBox-${clientId} .abbAlertBox{
			text-align: ${alignment};
		}
		#abbAlertBox-${clientId} .abbAlertBox .alert{
			text-align: ${textAlign};
			width: ${'0px' === width || '0%' === width || '0em' === width ? 'auto' : width};
			${typography?.styles || 'font-size: 25px;'}
			${colors?.styles || 'color: #333; background: #fff;'}
			padding: ${padding?.styles || '15px 30px'};
			${border?.styles || 'border: 2px solid #333; border-radius: 8px;'}
			box-shadow: ${shadow?.styles || 'none'};
		}
		#abbAlertBox-${clientId} .abbAlertBox .alert .alertIcon{
			font-size: ${typography?.fontSize || '25px'};
			color: ${colors?.color || '#333'};
		}
		#abbAlertBox-${clientId} .abbAlertBox .alert .alertClose{
			color: ${colors?.color || '#333'};
		}
		`.replace(/\s+/g, ' ')
	}} />;
}
export default Style;